import { render, staticRenderFns } from "./PropertyRelationComponent.vue?vue&type=template&id=64d94de1"
import script from "./PropertyRelationComponent.vue?vue&type=script&lang=js"
export * from "./PropertyRelationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports